import React from 'react';
import TableComponent from './TableComponent';
import { filterQuestions } from '../utils/miscFunctions';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

const languages = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Spanish' },
    { value: 'ch', label: 'Chinese' },
    { value: 'ru', label: 'Russian' },
    { value: 'fr', label: 'French' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'ar', label: 'Arabic' },
    { value: 'so', label: 'Somali' },
    { value: 'ko', label: 'Korean' }
]

const types = [
    { value: 'opinion_scale', label: 'Opinion scale' },
    { value: 'multiple_choice', label: 'Multiple choice' },
    { value: 'group', label: 'Group' },
    { value: 'statement', label: 'statement' },
    { value: 'long_text', label: 'Long text' },
    { value: 'short_text', label: 'Short text' },
    { value: 'yes_no', label: 'Yes/No' }
]


const styles = {
    'search': {
        width: '50%',
        margin: 10
    },
    'select': {
        width: '22%',
        margin: 5,
        height: 60,
        fontSize: 16,
    }
}

class SearchDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            typeFilter: '',
            languageFilter: this.props.languageFilter,
            filteredQuestions: [],
            searchTerm: '',
            page: 0,
            rowsPerPage: 8
        };
        this.updateState = this.updateState.bind(this);
    }

    componentDidMount(){
        this.updateState(this.props.data, 'filteredQuestions')
    }

    componentDidUpdate(prevProps) {
        if (this.props.languageFilter !== prevProps.languageFilter) {
            this.updateState(this.props.languageFilter, 'languageFilter');
        }
        if (this.props.data !== prevProps.data) {
            this.updateState(this.props.data, 'filteredQuestions')
        }
    }

    updateState(value, state) {
        this.setState({
            [state]: value
        }, () => {
            if (state === 'searchTerm' || state === 'languageFilter' || state === 'typeFilter' || state === 'filteredQuestions') {
                this.updateState(0, "page");
                let filteredQuestions = this.props.data.filter(filterQuestions(this.state.searchTerm));
                if (this.state.typeFilter) {
                    filteredQuestions = filteredQuestions.filter(question => question.type === this.state.typeFilter);
                }
                if (this.state.languageFilter) {
                    filteredQuestions = filteredQuestions.filter(question => question.language === this.state.languageFilter);
                }
                this.setState({
                    filteredQuestions: filteredQuestions
                })
            }
        })
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.toggleOpen}
                fullWidth={true}
                maxWidth={"md"}
            >
                <DialogContent>
                    <div style={{ display: 'flex', width: '100%' }}>
                        <TextField
                            id="search-input" variant="outlined"
                            value={this.state.searchTerm}
                            onChange={(e) => this.updateState(e.target.value, "searchTerm")}
                            InputProps={{ startAdornment: (<InputAdornment position="start"> <SearchIcon /> </InputAdornment>) }}
                            style={styles['search']}
                            autoComplete="off"
                        />
                        <select style={styles['select']} value={this.state.typeFilter} onChange={(e) => this.updateState(e.target.value, 'typeFilter')}>
                            <option value="">Type</option>
                            {types.map(type => (
                                <option key={type.value} value={type.value}> {type.label} </option>
                            ))}
                        </select>
                        <select style={styles['select']} value={this.state.languageFilter} onChange={(e) => this.updateState(e.target.value, 'languageFilter')}>
                            <option value="">Language</option>
                            {languages.map(language => (
                                <option key={language.value} value={language.value}> {language.label} </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <TableComponent
                            data={this.state.filteredQuestions}
                            headers={["Ref", "Text", "Type", "Language", "Date added"]}
                            fields={["ref", "title", "type", "language", "dateAdded"]}
                            updateState={this.updateState}
                            onRowClick={this.props.onRowClick}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            count={this.state.filteredQuestions.length}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.toggleOpen} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
};


export default SearchDialog;
